import React from 'react';
import {
  IconAccount,
  IconLock,
  IconBusiness,
  IconDocument,
  IconCheck,
  IconPlay,
  IconInfo,
  IconSuccess,
  IconStatementReady,
  IconP2p,
  IconMembership,
  IconBank,
  IconUnlock,
} from '@americanexpress/dls-icons';

export const getIcon = (iconName) => {
  switch (iconName) {
    case 'IconLock':
      return <IconLock />;
    case 'IconUnlock':
      return <IconUnlock />;
    case 'IconAccount':
      return <IconAccount />;
    case 'IconBusiness':
      return <IconBusiness />;
    case 'IconDocument':
      return <IconDocument />;
    case 'IconCheck':
      return <IconCheck />;
    case 'IconPlay':
      return <IconPlay />;
    case 'IconInfo':
      return <IconInfo />;
    case 'IconSuccess':
      return <IconSuccess />;
    case 'IconP2p':
      return <IconP2p />;
    case 'IconStatementReady':
      return <IconStatementReady />;
    case 'IconMembership':
      return <IconMembership />;
    case 'IconBank':
      return <IconBank />;
    default:
      return '';
  }
};
